import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/providers/api.service';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';
import { COUNTRY_CODES } from 'src/app/shared/data/country-codes';

@Component({
  selector: 'sm-invoice-share-by-whatsapp',
  templateUrl: './invoice-share-by-whatsapp.component.html',
  styleUrls: ['./invoice-share-by-whatsapp.component.scss']
})
export class InvoiceShareByWhatsappComponent implements OnInit, OnDestroy {
  isEntityForeign: string = localStorage.getItem(SM_CONSTANTS.IS_ENTITY_FOREIGN)!
  number:any
  apisub: Subscription
  constructor(private activemodal: MatDialogRef<InvoiceShareByWhatsappComponent>,@Inject(MAT_DIALOG_DATA) public parentdata:any, private loaderservice: LoaderServiceService, private apiservice: ApiService) {

    this.apisub = this.apiservice.apiResult.subscribe(resdata => {
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_GENERATE_INVOICE_PDF){
        if(resdata.result){
          this.loaderservice.showLoader = false
          this.activemodal.close(resdata.result)
        }
      }
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_GENERATE_INTERNATIONAL_INVOICE_PDF){
        if(resdata.result){
          this.loaderservice.showLoader = false
          this.activemodal.close(resdata.result)
        }
      }
    })



   }

  ngOnInit(): void {
    console.log(this.parentdata);
    this.selectedCountryCode = this.countryList.find(country => country.dial_code === this.parentdata.countryCode)
    this.number = this.parentdata.phone
    // this.email = sessionStorage.getItem('mefrp') && sessionStorage.getItem('mefrp') != 'null' ? sessionStorage.getItem('mefrp') : null
  }
  shareViaEmail(){


    if(this.isEntityForeign == '0'){
      this.loaderservice.showLoader = true
      let obj = {
        "entity_hash": this.parentdata.entityHash, 
        "country_code": this.selectedCountryCode.dial_code, 
        "customer_phone": this.number
    }
    console.log(obj);
    
    this.apiservice.generateInvoicePDF(this.parentdata.invoiceHash, obj)
    }
    else if(this.isEntityForeign == '1'){
      this.loaderservice.showLoader = true
      let obj = {
        "invoiceHash": this.parentdata.invoiceHash, 
        "entity_hash": this.parentdata.entityHash,
        "country_code": this.selectedCountryCode.dial_code, 
        "customer_phone": this.number
    }
    console.log(obj);

    this.apiservice.generateInternationalInvoicePDF(obj)
    
    }
  }

  ngOnDestroy(): void {
    this.apisub.unsubscribe()
  }
  countryList: {name: string; dial_code: string; code: string; flag: string; preferred?: any;}[] = COUNTRY_CODES;
  selectedCountryCode:any = this.countryList.find(country => country.dial_code === '+91')
  searchString: FormControl = new FormControl('');
  onCountrySelected(event: any): void {
    this.searchString.reset()
    this.countryList = COUNTRY_CODES
  }
  
  onKey() { 
    console.log(this.searchString.value);
    
    this.countryList= []; 
    this.selectSearch(this.searchString.value);       
  }
  selectSearch(value:string){
    let filter = value.toLowerCase();
    for ( let i = 0 ; i < COUNTRY_CODES.length; i ++ ) {
        let option = COUNTRY_CODES[i];
        if (  option.name.toLowerCase().indexOf(filter) >= 0) {
            this.countryList.push( option );
        }
    }
  }
  checkdis(){

    //   if (!this.email || this.email.trim() === '' || this.email == undefined) {
    //     return true;
    //   }
    //   // Clean and split the email addresses
    //   let cleanedEmails = this.email
    //     .replace(/^[,\s]+|[,\s]+$/g, '')
    //     .replace(/\s*,\s*/g, ',')
    //     .split(',');
  
    //   // Check for invalid emails
    //   let hasInvalidEmail = cleanedEmails.some((email:any) => !this.isValidEmail(email));
  
    //   // Disable if any invalid email exists
    //   return hasInvalidEmail;
    
    // return true; // Default disable
  }
  
  isValidEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }
}

